import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SCREEN_CONFIG } from '@config/screenConfig';
import * as React from 'react';
import { FooterScreen as SharedFooterScreen } from '~shared/components/Footer/FooterScreen';
import { WaiterFooter } from './WaiterFooter';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Screen wrapper that renders its children inside a layout with speedlo-footer.
 * Provided props will be passed to the inner container (Box) to style the content (children).
 */
export var FooterScreen = function FooterScreen(_ref) {
  var children = _ref.children,
      containerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(SharedFooterScreen, _objectSpread(_objectSpread({
    screenBgColor: SCREEN_CONFIG.bgColor,
    footer: /*#__PURE__*/_jsx(WaiterFooter, {})
  }, containerProps), {}, {
    children: children
  }));
};